<template>
  <ModalComponent
    @closed="
      () => {
        onIframeClosed()
      }
    "
    ref="component"
  >
    <div class="relative h-screen top-0 left-0 flex justify-center">
      <div class="absolute w-full z-10">
        <div class="flex justify-end p-4 w-full left-0">
          <div class="cursor-pointer" @click="onDismissClick">
            <img
              src="@/assets/images/icons/cancel.svg"
              class="w-[30px] h-[30px] cursor-pointer border-gray-800"
              alt=""
            />
          </div>
        </div>
      </div>
      <iframe
        :src="link"
        frameborder="0"
        :class="['border-none  absolute  ', iframeClasses || 'w-full h-full ']"
      ></iframe>
    </div>
  </ModalComponent>
</template>

<script>
import { defineComponent } from 'vue'
import ModalComponent from '../utils/ModalComponentFullScreen.vue'

export default defineComponent({
  name: 'LinkOpener',
  components: { ModalComponent },
  props: {},
  data() {
    return {
      eventsIds: [],
      link: '',
      iframeClasses: '',
      askCloseConfirmation: false,
      closeConfirmTitle: '',
      closeConfirmSubtitle: '',
    }
  },
  mounted() {
    const id = this.$Events.handleEvent('url_opening_required', this.openUrl)
    const id2 = this.$Events.handleEvent('close_iframe', this.closeIframe)
    this.eventsIds.push(id)
    this.eventsIds.push(id2)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    openUrl({
      url,
      title,
      subTitle,
      allowManyOpening,
      withPrompt,
      useIframe,
      iframeClasses,
      closeConfirmTitle,
      closeConfirmSubtitle,
      closeConfirmButton,
      closeCancelButton,
      openInCurrentTab,
    }) {
      this.$Events.dispatchEvent('finish_loading')
      if (!url) return
      if (!window.openedUrls) window.openedUrls = []
      if (window.openedUrls.includes(url) && !allowManyOpening) return
      setTimeout(() => {
        if (withPrompt) {
          window.customPrompt({
            title: title || this.$t('linkOpener.defaultTitle'),
            subTitle: subTitle || this.$t('linkOpener.defaultTitle', { url }),
          })
        }
        if (useIframe) {
          this.link = url
          this.iframeClasses = iframeClasses || ''
          this.closeConfirmTitle = closeConfirmTitle || ''
          this.closeConfirmSubtitle = closeConfirmSubtitle || ''
          this.closeConfirmButton = closeConfirmButton || 'Quitter'
          this.closeCancelButton = closeCancelButton || 'Annuler'
          this.$refs.component.show()
          return
        }
        console.log('will open', url)
        if (openInCurrentTab) window.open(url, '_self')
        else window.open(url, '_blank')
        window.openedUrls.push(url)
      }, 1000)
    },
    async onDismissClick() {
      this.$refs.component.show()
      if (this.askCloseConfirmation) return
      await new Promise(r => setTimeout(r, 500))
      if (!this.closeConfirmTitle) {
        this.$refs.component.hide()
        return
      }
      this.askCloseConfirmation = true
      const prompt = await window.customPrompt({
        title: this.closeConfirmTitle,
        subTitle: this.closeConfirmSubtitle,
        successText: this.closeConfirmButton,
        cancelText: this.closeCancelButton,
      })
      if (prompt.accepted) {
        await new Promise(r => setTimeout(r, 500))
        this.$refs.component.hide()
      }
      setTimeout(() => {
        this.askCloseConfirmation = false
      }, 500)
      console.log(prompt)
      // $refs.component.hide();
    },
    closeIframe() {
      this.$refs.component.hide()
    },
    onIframeClosed() {
      this.$Events.dispatchEvent('iframe_closed', { url: this.link })
    },
  },
  computed: {},
})
</script>
